import * as React from "react";
const SvgIconSparkle = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", ...props }, /* @__PURE__ */ React.createElement("path", { fill: "#fff", fillOpacity: 0.8, d: "m4 8 3.66-.34L8 4l.34 3.66L12 8l-3.66.34L8 12l-.34-3.66z" }));
export default SvgIconSparkle;
